import { config } from 'helpers'

//* Components
import Button from 'components/common/Button'
import CustomLink from 'components/common/CustomLink'

//* Style
import BackButtonStyle from './style'

const BackButton = ({ backRoute, prevRoute, text, isEvent, isArticle }) => {
	return (
		<BackButtonStyle className={prevRoute || isEvent || isArticle ? '' : 'disable'}>
			<CustomLink url={isEvent ? config.routes.events.path : prevRoute ? prevRoute.asPath : backRoute} className='back-link'>
				<Button type={'back'} text={text} />
			</CustomLink>
		</BackButtonStyle>
	)
}

export default BackButton
